// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c99f438","879":"fa8915bb"}[chunkId] + ".chunk.js";
};